import { CONTENT_TYPE_TO_URL } from "config/constants/editor";
import DashboardByline from "dashboard/components/DashboardByline";
import DashboardDate from "dashboard/components/DashboardDate";
import DashboardHeadline from "dashboard/components/DashboardHeadline";
import StatusIcon from "dashboard/components/StatusIcon";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import getEditorURL from "editor/utils/getEditorURL";

import styles from "./DashboardStorySmall.css";

export default function DashboardStorySmall(props) {
  const story = props.story;
  const contentType =
    CONTENT_TYPE_TO_URL[story.content_type] || story.editorType;

  return (
    <Link
      to={getEditorURL(contentType, story.id, true)}
      className={styles.root}
    >
      <DashboardByline authors={story.authors} editors={story.editors} />
      <StatusIcon status={story.status} />

      <div className={styles.headlineContainer}>
        <DashboardHeadline
          headline={story.headline}
          id={story.id}
          isPrivate={story.isPrivate}
          type={story.content_type}
        />
      </div>

      <div className={styles.row}>
        <div className={styles.dateContainer}>
          <DashboardDate
            last_updated={story.last_updated}
            scheduled_date={story.scheduled_date}
            published_date={story.published_date}
            eta={story.eta}
            status={story.status}
            in_edits={story.in_edits}
            showPublishedDatetime={props.showPublishedDatetime}
            lock={story.lock}
          />
        </div>
      </div>
    </Link>
  );
}

DashboardStorySmall.propTypes = {
  story: PropTypes.object.isRequired,
  showPublishedDatetime: PropTypes.bool,
};
